export default __webpack_public_path__ + "static/media/img_emerg.9134756e.svg";